module.exports = __webpack_public_path__ + "img/customer-app-order-details.4d1ce5fa.png";